<template>
  <v-row>
      <v-col class="pt-0 caption">
        <span v-show="hideTaskAggRows">Click<v-btn class="app-bar-text" icon @click="emptyRowsHide()"><v-icon>{{rowsToggleIcon}}</v-icon></v-btn>to reveal all rows with 0's.</span>
        <span v-show="!hideTaskAggRows">Click<v-btn class="app-bar-text" icon @click="emptyRowsHide()"><v-icon>{{rowsToggleIcon}}</v-icon></v-btn>to hide all rows with 0's.</span>
      </v-col>
    </v-row>
</template>

<script>
import CacheHandler from "@/utils/CacheHandler";
export default {
  components: {},
  data() {
    return {
      hideTaskAggRows: CacheHandler.getItem("hide_empty_task_aggregate_rows") === "true",
    };
  },
  methods: {
    emptyRowsHide() {
      this.hideTaskAggRows = !this.hideTaskAggRows
      CacheHandler.setItem("hide_empty_task_aggregate_rows", this.hideTaskAggRows ? 'true' : 'false' )
      this.$emit("hide-task-agg-rows", this.hideTaskAggRows)
    },
  },
  computed: {
    rowsToggleIcon() {
      return (this.hideTaskAggRows) ? 'mdi-eye' : 'mdi-eye-off'
    },

  },
  mounted() {},
  watch: {}
};
</script>

<style scoped></style>
